import { useCombinedQueriesTeamGeneralInfo } from '@/hooks/query/useCombinedQueriesTeamGeneralInfo';

/**
 * Returns whether the current user's team roles are explicitly allowlisted to
 * review other members' full session lists. Support-category bypasses are
 * handled by callers to preserve the existing frontend behavior.
 */
export function useCanReviewOtherUsersSessionList() {
  const { teamDetails, userRoleIds } = useCombinedQueriesTeamGeneralInfo();

  const allowViewOthers =
    teamDetails?.team.session_configuration?.allow_view_others_sessions ?? false;
  const allowedRoleIds =
    teamDetails?.team.session_configuration?.role_ids_can_view_others_sessions ?? [];

  return Boolean(
    allowViewOthers && userRoleIds?.some((roleId) => allowedRoleIds.includes(roleId))
  );
}
